import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SendComponent } from './views/send.component';

const routes: Routes = [
  {
    path: '',
    component: SendComponent,
    loadChildren: () => import('../details-document/details-document.module').then( m => m.DetailsDocumentModule )
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SendRoutingModule { }
